<br>
<div style="width:95%">
  <span> <button class="btn btn border" (click)="savePayment()">Spara</button> <button class="btn btn border" style="margin-left:20px;" (click)="cancel()">Avbryt</button></span>
  <br><br>
  <br>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-6">
        <label>
          Datum
        </label>
        <input id="paidDate" type="text" class="form-control form-control-sm" formControlName="paidDate">
      </div>
      <div class="col-md-5">
        <label>
          Belopp
        </label>
        <input id="paidAmount" type="text" class="form-control form-control-sm" formControlName="paidAmount">
      </div>
    </div>
  </form>
</div>